/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hexadecimal (base 16)`)
};

const es_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hexadecimal (base 16)`)
};

const de_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hexadezimal (Basis 16)`)
};

const nl_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hexadecimaal (basis 16)`)
};

const fr_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hexadécimal (base 16)`)
};

const it_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esadecimale (base 16)`)
};

const pt_br2_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hexadecimal (base 16)`)
};

const pt_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hexadecimal (base 16)`)
};

const ja_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十六進法（基数 16）`)
};

const zh_nb_base16 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十六进制（16 进制）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_base16 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_base16(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_base16", locale)
	if (locale === "en") return en_nb_base16(inputs)
	if (locale === "es") return es_nb_base16(inputs)
	if (locale === "de") return de_nb_base16(inputs)
	if (locale === "nl") return nl_nb_base16(inputs)
	if (locale === "fr") return fr_nb_base16(inputs)
	if (locale === "it") return it_nb_base16(inputs)
	if (locale === "pt-BR") return pt_br2_nb_base16(inputs)
	if (locale === "pt") return pt_nb_base16(inputs)
	if (locale === "ja") return ja_nb_base16(inputs)
	return zh_nb_base16(inputs)
};